import React, { useEffect, useState } from 'react';
import api from '../api';
import { format } from 'date-fns';

export default function LoginHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/auth/login-history')
      .then(r => setHistory(r.data))
      .finally(() => setLoading(false));
  }, []);

  const exportCSV = () => {
    const BOM = '\uFEFF';
    const headers = ['Staff Name', 'Email', 'Role', 'Login Time', 'IP Address'];
    const rows = history.map(h => [
      h.full_name, h.email,
      h.role.replace(/_/g, ' '),
      format(new Date(h.created_at), 'dd/MM/yyyy HH:mm:ss'),
      h.ip_address || 'Unknown',
    ]);
    const csv = BOM + [headers, ...rows]
      .map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(','))
      .join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `OMIYE-MFB-LoginHistory-${format(new Date(), 'dd-MM-yyyy')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="section-head" style={{ marginBottom: 16 }}>
        <div>
          <div className="section-title">🔐 Login History</div>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 3 }}>
            Last 100 login records across all staff
          </div>
        </div>
        <button className="btn btn-success btn-sm" onClick={exportCSV}>📥 Export CSV</button>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Staff Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Login Time</th>
              <th>IP Address</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} style={{ textAlign: 'center', padding: 40, color: 'var(--muted)' }}>Loading…</td></tr>}
            {!loading && history.length === 0 && (
              <tr><td colSpan={5}>
                <div className="empty-state">
                  <div className="empty-icon">🔐</div>
                  <div>No login history yet</div>
                </div>
              </td></tr>
            )}
            {history.map(h => (
              <tr key={h.id} style={{ cursor: 'default' }}>
                <td style={{ fontWeight: 500 }}>{h.full_name}</td>
                <td style={{ fontSize: 12, color: 'var(--muted)' }}>{h.email}</td>
                <td style={{ fontSize: 12, textTransform: 'capitalize' }}>{h.role?.replace(/_/g, ' ')}</td>
                <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                  {format(new Date(h.created_at), 'dd MMM yyyy, HH:mm:ss')}
                </td>
                <td style={{ fontSize: 12, color: 'var(--muted)', fontFamily: 'monospace' }}>
                  {h.ip_address || 'Unknown'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
